import { Checkbox } from "@hawkins/components";
import { useField } from "formik";
import React, { useCallback } from "react";
const FormikCheckbox = ({ name, onChange, ...rest }) => {
  const [{ value, ...fieldRest }, , helpers] = useField(name);
  const handleChange = useCallback(
    (event, checked) => {
      helpers.setValue(checked);
      if (onChange) {
        onChange(event, checked);
      }
    },
    [helpers, onChange]
  );
  return /* @__PURE__ */ React.createElement(Checkbox, { ...fieldRest, checked: value, onChange: handleChange, ...rest });
};
export {
  FormikCheckbox
};
//# sourceMappingURL=FormikCheckbox.js.map
